const verticalSpacing = (space) => {
  switch (space) {
    case "none":
      return "";

    case "x-small":
      return "margin-xsmall";

    case "small":
      return "margin-small";

    case "medium":
      return "margin-medium";

    case "large":
      return "margin-large";

    case "x-large":
      return "margin-xlarge";

    default:
      return null;
  }
};

export default verticalSpacing;
